// Base API URL
export const API_URL = 'https://avikeli.com/';
export const MEDIA_URL = API_URL + 'media/';

// Login Endpoints
const LOGIN_PATH = 'accounts';
export const LOGIN_ENDPOINT = `${API_URL}${LOGIN_PATH}/login`;
export const REGISTER_ENDPOINT = `${API_URL}${LOGIN_PATH}/register`;
export const APPROVE_ENDPOINT = `${API_URL}${LOGIN_PATH}/approve/`;

// Landing Endpoints
const LANDING_PATH = 'highlights';
export const ADS_ENDPOINT = `${API_URL}${LANDING_PATH}/advertisement`;
export const SPONSORS_ENDPOINT = `${API_URL}${LANDING_PATH}/brand-logo`;
export const HL_PRODUCTS_ENDPOINT = `${API_URL}${LANDING_PATH}/popular-product`;

// Product Endpoints
const PRODUCT_PATH = 'product';
export const PRODUCTS_ENDPOINT = `${API_URL}${PRODUCT_PATH}/catalog`;
export const FILTERS_ENDPOINT = `${API_URL}${PRODUCT_PATH}/categories`;
export const BRANDS_ENDPOINT = `${API_URL}${PRODUCT_PATH}/brands`;

// Order Endpoints
const ORDER_PATH = 'order';
export const AVAILABLE_DATES_ENDPOINT = `${API_URL}${ORDER_PATH}/settings`;
export const MAKE_ORDER_ENDPOINT = `${API_URL}${ORDER_PATH}/place`;
export const ORDERS_ENDPOINT = `${API_URL}${ORDER_PATH}/records/user`;
export const ORDER_PDF_ENDPOINT = `${API_URL}${ORDER_PATH}/resume/`;

// Social
const SOCIAL_PATH = 'whatsapp';
export const WPP_SETTINGS_ENDPOINT = `${API_URL}${SOCIAL_PATH}/info`;
export const LINKEDIN_PROFILE = "https://www.linkedin.com/in/avikeli/"
export const INSTAGRAM_PROFILE = "https://www.instagram.com/avikeli_ok/"
